import axios, { AxiosRequestConfig } from 'axios'
import {
  ConfirmReceivedAmountRequestDto,
  ConfirmReceivedAmountResponseDto,
  RequestSettlementRequestDto,
  RequestSettlementResponseDto,
} from '@sparling/financial-common'

export const confirmReceivedAmount = async (
  { walletId, amount, token }: ConfirmReceivedAmountRequestDto & { token: string }, // eslint-disable-line
  options: AxiosRequestConfig = {}, // eslint-disable-line
): Promise<{ data: ConfirmReceivedAmountResponseDto }> => {
  const response = await axios.post(
    `${process.env.REACT_APP_REST_API_URL}/user/wallets/confirm-received-amount`,
    {
      walletId,
      amount,
    },
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const requestSettlement = async (
  { token, ...params }: RequestSettlementRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<RequestSettlementResponseDto> => {
  const response = await axios.post<RequestSettlementResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/transactions/request-settlement`,
    params,
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}
